import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TermoAcumulatorTA0Description = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}> Termo-acumulator rotund</span> fără schimbător de căldură</p>
      <p className={styles.text}>
Boiler vertical pentru apa menajera ALTEP ТА0, ТА90, ТА180, destinat acumulării , conservării și transferului de energie termica sub forma de apa către sistemul de încălzire. Pentru cazurile în care este necesara o acumulare gradata de energie pentru consumul de căldura.      </p>
      <p className={styles.text}>
        Rezervoarele tampon sunt proiectate pentru funcționarea continua fără supraveghere, cu condiția respectării regulilor de instalare și funcționare.
      </p>
      <p className={styles.text}>
        Termoizolarea de la 200 la 1500 l – 100 mm : țesătura hidro-rezistenta cordura – material ușor și rezistent.
      </p>
      <p className={styles.text}>
        Pentru izolarea boilerului este folosita vata minerala ISOVER.
      </p>
      <p className={styles.text}>
        Datorita caracteristicilor țesăturii.
      </p>
      <p className={styles.text}>
        Rezistă la ardere și expunere la UV.
      </p>
      <p className={styles.text}>
        Vată minerală ISOVER este utilizată pentru izolare.
      </p>
      <p className={styles.text}>
        Izolație termică de la 2000 la 10000 litri. - 100 mm: piele fauxă și spumă poliuretanică.
      </p>
    </div>
  );
};